import UltMeta, { Meta } from "./UltMeta/index";

class AddressType extends UltMeta {
    LOADING_ADDRESS = new Meta(1, "装货地");
    UNLOADING_ADDRESS = new Meta(2, "卸货地");
    APPROACH_LOADING_ADDRESS = new Meta(3, "途径装货地");
    APPROACH_UNLOADING_ADDRESS = new Meta(4, "途径卸货地");
}

export const ADDRESS_TYPE = new AddressType();
